'use client'

import React from 'react'

type Props = {
    base: number
    height: number
    sideB: number
}

const WIDTH = 340
const HEIGHT = 220

export default function ParallelogramChart({ base, height, sideB }: Props) {
    const maxDim = Math.max(base, height, 0.0001)
    const scale = 140 / maxDim
    const b = Math.max(base * scale, 20)
    const h = Math.max(height * scale, 20)
    const skew = Math.min(h * 0.6, 50)

    const x0 = (WIDTH - b - skew) / 2
    const y0 = (HEIGHT + h) / 2

    const A = [x0, y0]
    const B = [x0 + b, y0]
    const C = [x0 + b + skew, y0 - h]
    const D = [x0 + skew, y0 - h]

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <polygon points={`${A.join(',')} ${B.join(',')} ${C.join(',')} ${D.join(',')}`} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            <line x1={D[0]} y1={D[1]} x2={D[0]} y2={A[1]} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <text x={(A[0] + B[0]) / 2} y={A[1] + 20} fontSize={12} textAnchor="middle" fill="#374151">base = {base.toFixed(2)}</text>
            <text x={D[0] + 12} y={(D[1] + A[1]) / 2} fontSize={12} textAnchor="start" fill="#374151">h = {height.toFixed(2)}</text>
            <text x={(A[0] + D[0]) / 2 - 18} y={(A[1] + D[1]) / 2} fontSize={12} textAnchor="middle" fill="#374151">s = {sideB.toFixed(2)}</text>
        </svg>
    )
}
